<div class="mb-3">
  <div class="mb-3">

    <h1 class="pb-2 border-bottom fw-light" i18n>Artikel</h1>

    <div class="mt-3">
      <app-product-search (searchCriteria)="search($event)"></app-product-search>
    </div>

    <kendo-grid
      [data]="list.gridData"
      [pageable]="true"
      [skip]="list.state.skip"
      [pageSize]="list.state.pageSize"
      [sortable]="true"
      [sort]="list.state.sort"
      (pageChange)="list.onPageChange($event)"
      (sortChange)="list.onSortChange($event)"
      [reorderable]="true"
      [resizable]="true">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="list.loading" loadingText="Artikel werden geladen…" i18n-loadingText></app-grid-no-records>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
        @if (profile?.customer && isAdmin) {
          <button class="btn btn-primary ms-auto" [routerLink]="['/sku-edit']" i18n>Neuen Artikel erstellen</button>
        }
      </ng-template>

      <kendo-grid-column field="number" i18n-title title="Artikelnummer" format="{0:g}" [width]="80">
      </kendo-grid-column>
      <kendo-grid-column field="name1" i18n-title title="Artikelname 1" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.name1 }}
          @if (dataItem.isImported) {
            <span class="badge text-bg-info ms-1"
              title="Aus einem Scan importiert – Name, Beschreibung, GTIN und Preise werden beim nächsten Scan überschrieben."
              i18n-title="@@sku.imported.badge.title"
              i18n="@@sku.imported.badge">Importiert</span>
          }
          @if (dataItem.isVatUndetermined) {
            <!-- Backend #579: the listing is unsellable until the seller sets a VAT rate. -->
            <span class="badge text-bg-warning ms-1"
              title="MwSt.-Satz noch nicht festgelegt – der Artikel ist für Käufer unsichtbar und nicht bestellbar, bis Sie einen Steuersatz wählen."
              i18n-title="@@sku.vatUndetermined.badge.title"
              i18n="@@sku.vatUndetermined.badge">MwSt. offen</span>
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="availableQuantity" [sortable]="false" i18n-title title="Bestand" [width]="80">
      </kendo-grid-column>
      <kendo-grid-column field="catalogGrossPrice" [sortable]="false" i18n-title title="VK" [width]="80">
        <!-- Per-row currency (#525): format="{0:c}" prints the LOCALE's symbol (€ under de)
             and ignores the row — an imported USD/GBP listing would be mislabeled. -->
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.catalogGrossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <!-- #633 A: the tag set in a narrow column — first name + „+n", full list as tooltip;
           empty = a deliberately uncategorized listing.
           #178 / backend #688: `categoryNames` prefers the backend's resolved display names over
           the stable keys, which is what put „WerkzeugeMaschinen" in this column in both
           languages. -->
      <kendo-grid-column field="productCategoryNames" i18n-title title="Kategorie" [width]="120" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (categoryNames(dataItem).length) {
            <span [title]="categoryNames(dataItem).join(', ')">
              {{ categoryNames(dataItem)[0] }}@if (categoryNames(dataItem).length > 1) {&nbsp;+{{ categoryNames(dataItem).length - 1 }}}
            </span>
          } @else {
            <span class="text-muted">—</span>
          }
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column i18n-title title="Bearbeiten" [width]="80">
        @if (profile?.customer && isAdmin; as dataItem) {
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="d-flex justify-content-center gap-2">
              <button type="button" class="btn btn-sm btn-outline-danger"
                title="Löschen" aria-label="Löschen" i18n-title i18n-aria-label
                data-testid="sku-list-delete-button"
                [asyncClick]="onDelete(dataItem.id)" [disabled]="delBtn.disabled" #delBtn="asyncClick">
                @if (delBtn.busy) { <span class="spinner-border spinner-border-sm"></span> } @else {
                <fa-icon [icon]="faTrashAlt"></fa-icon>
                }
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary"
                title="Bearbeiten" aria-label="Bearbeiten" i18n-title i18n-aria-label
                (click)="onEdit(dataItem.id)">
                <fa-icon [icon]="faEdit"></fa-icon>
              </button>
            </div>
          </ng-template>
        }
      </kendo-grid-command-column>

      <kendo-grid-pdf appGridPdf fileName="Artikel.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.7">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <app-pdf-page title="Artikelliste" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
        </ng-template>
      </kendo-grid-pdf>
    </kendo-grid>

  </div>
</div>